import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import FaqCategoryNewPage from 'src/pages/dashboard/faqCategory/new';
import FaqNewPage from 'src/pages/dashboard/faq/new';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/analytics'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const OverviewAnalyticsPage = lazy(() => import('src/pages/dashboard/analytics'));
const OverviewBankingPage = lazy(() => import('src/pages/dashboard/banking'));
const OverviewBookingPage = lazy(() => import('src/pages/dashboard/booking'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));
// CURRENCY EXCHANGE
const CurrencyExchangeRateFormPage = lazy(() => import('src/pages/dashboard/currency-exchange-rate/form'));
// PRODUCT
const ProductDetailsPage = lazy(() => import('src/pages/dashboard/product/details'));
const ProductListPage = lazy(() => import('src/pages/dashboard/product/list'));
const ProductCreatePage = lazy(() => import('src/pages/dashboard/product/new'));
const ProductEditPage = lazy(() => import('src/pages/dashboard/product/edit'));
// ORDER
const OrderListPage = lazy(() => import('src/pages/dashboard/order/list'));
const OrderDetailsPage = lazy(() => import('src/pages/dashboard/order/details'));
// INVOICE
const InvoiceListPage = lazy(() => import('src/pages/dashboard/invoice/list'));
const InvoiceDetailsPage = lazy(() => import('src/pages/dashboard/invoice/details'));
const InvoiceCreatePage = lazy(() => import('src/pages/dashboard/invoice/new'));
const InvoiceEditPage = lazy(() => import('src/pages/dashboard/invoice/edit'));
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
const UserEventPage = lazy(() => import('src/pages/dashboard/user/View'))

// CATEGORY
const CategoryListPage = lazy(() => import('src/pages/dashboard/category/list'));
const CategoryCreatePage = lazy(() => import('src/pages/dashboard/category/new'));
const CategoryEditPage = lazy(() => import('src/pages/dashboard/category/edit'));
const CategoryViewPage = lazy(() => import('src/pages/dashboard/category/view'));

// FAQ CATEGORY
const FaqCategoryListPage = lazy(() => import('src/pages/dashboard/faqCategory/list'));
const FaqCategoryCreatePage = lazy(() => import('src/pages/dashboard/faqCategory/new'));
const FaqCategoryEditPage = lazy(() => import('src/pages/dashboard/faqCategory/edit'));
const FaqCategoryViewPage = lazy(() => import('src/pages/dashboard/faqCategory/view'));

// PROFILE ANALYTICS
const ProfileAnalyticsListPage = lazy(()=> import('src/pages/dashboard/profile-analytics/list'))
// FAQ
const FaqListPage = lazy(() => import('src/pages/dashboard/faq/list'));
const FaqCreatePage = lazy(() => import('src/pages/dashboard/faq/new'));
const FaqEditPage = lazy(() => import('src/pages/dashboard/faq/edit'));
const FaqViewPage = lazy(() => import('src/pages/dashboard/faq/view'));

// BATCHES

const BatchesNewPage = lazy(() => import('src/pages/dashboard/batches/new'));
const BatchesListPage = lazy(() => import('src/pages/dashboard/batches/list'));
const BatchesEditPage = lazy(() => import('src/pages/dashboard/batches/edit'))

// BLOG
const BlogPostsPage = lazy(() => import('src/pages/dashboard/post/list'));
const BlogPostPage = lazy(() => import('src/pages/dashboard/post/details'));
const BlogNewPostPage = lazy(() => import('src/pages/dashboard/post/new'));
const BlogEditPostPage = lazy(() => import('src/pages/dashboard/post/edit'));
const BlogAuthorListPage = lazy(() => import('src/pages/dashboard/blog-author/list'));
const BlogAuthorCreatePage = lazy(() => import('src/pages/dashboard/blog-author/new'));
const BlogAuthorEditPage = lazy(() => import('src/pages/dashboard/blog-author/edit'));
// JOB
const JobDetailsPage = lazy(() => import('src/pages/dashboard/job/details'));
const JobListPage = lazy(() => import('src/pages/dashboard/job/list'));
const JobCreatePage = lazy(() => import('src/pages/dashboard/job/new'));
const JobEditPage = lazy(() => import('src/pages/dashboard/job/edit'));
// Plan
const PlanListPage = lazy(() => import('src/pages/dashboard/plan/list'));
const PlanCreatePage = lazy(() => import('src/pages/dashboard/plan/new'));
const PlanEditPage = lazy(() => import('src/pages/dashboard/plan/edit'));
const CourseListPage = lazy(() => import('src/pages/dashboard/plan/courseList'))
const ServiceListPage = lazy(() => import('src/pages/dashboard/plan/serviceList'));


// Subscriptions

const SubscriptionListPage = lazy(() => import('src/pages/dashboard/subscription/list'));
const SubscriptionDetailsPage = lazy(() => import('src/pages/dashboard/subscription/details'));

// Email
const EmailListPage = lazy(() => import('src/pages/dashboard/email/list'));

// ContactUs
const ContactListPage = lazy(() => import('src/pages/dashboard/contact/list'));

// CMS (Strapi-backed catalog preview)
const CmsPlaysListPage = lazy(() => import('src/pages/dashboard/cms-plays/list'));
const CmsPlayNewPage = lazy(() => import('src/pages/dashboard/cms-plays/new'));
const CmsPlayEditPage = lazy(() => import('src/pages/dashboard/cms-plays/edit'));
const LearnerProgressListPage = lazy(() => import('src/pages/dashboard/learner-progress/list'));
const LearnerProgressUserPage = lazy(() => import('src/pages/dashboard/learner-progress/user'));
const LearnerProgressDetailsPage = lazy(() => import('src/pages/dashboard/learner-progress/details'));
const PricingTiersListPage = lazy(() => import('src/pages/dashboard/pricing-tiers/list'));
const PricingTierNewPage = lazy(() => import('src/pages/dashboard/pricing-tiers/new'));
const PricingTiersGrantPage = lazy(() => import('src/pages/dashboard/pricing-tiers/grant'));
const PricingTierEditPage = lazy(() => import('src/pages/dashboard/pricing-tiers/edit'));
const PricingPlansListPage = lazy(() => import('src/pages/dashboard/pricing-plans/list'));
const PricingPlanNewPage = lazy(() => import('src/pages/dashboard/pricing-plans/new'));
const PricingPlanEditPage = lazy(() => import('src/pages/dashboard/pricing-plans/edit'));
const DomainsListPage = lazy(() => import('src/pages/dashboard/domains/list'));
const DomainNewPage = lazy(() => import('src/pages/dashboard/domains/new'));
const DomainEditPage = lazy(() => import('src/pages/dashboard/domains/edit'));
const SubDomainsListPage = lazy(() => import('src/pages/dashboard/sub-domains/list'));
const SubDomainNewPage = lazy(() => import('src/pages/dashboard/sub-domains/new'));
const SubDomainEditPage = lazy(() => import('src/pages/dashboard/sub-domains/edit'));
const MarketingHomePage = lazy(() => import('src/pages/dashboard/marketing-home'));
const MarketingBannerPage = lazy(() => import('src/pages/dashboard/marketing-banner'));
const MarketingFaqsListPage = lazy(() => import('src/pages/dashboard/marketing-faqs/list'));
const MarketingFaqNewPage = lazy(() => import('src/pages/dashboard/marketing-faqs/new'));
const MarketingFaqEditPage = lazy(() => import('src/pages/dashboard/marketing-faqs/edit'));
const TestimonialsListPage = lazy(() => import('src/pages/dashboard/testimonials/list'));
const TestimonialNewPage = lazy(() => import('src/pages/dashboard/testimonials/new'));
const TestimonialEditPage = lazy(() => import('src/pages/dashboard/testimonials/edit'));
const NativityTemplatesListPage = lazy(() => import('src/pages/dashboard/nativity-templates/list'));
const PlayPlatformSettingsPage = lazy(() => import('src/pages/dashboard/play-platform-settings'));
const MemorySettingsPage = lazy(() => import('src/pages/dashboard/memory-settings'));
const MemoryInsightsHomePage = lazy(() => import('src/pages/dashboard/memory-insights'));
const MemoryInsightsUsersPage = lazy(() => import('src/pages/dashboard/memory-insights/users'));
const MemoryInsightsUserPage = lazy(() => import('src/pages/dashboard/memory-insights/user-detail'));
const NativityTemplateNewPage = lazy(() => import('src/pages/dashboard/nativity-templates/new'));
const NativityTemplateEditPage = lazy(() => import('src/pages/dashboard/nativity-templates/edit'));

// TOUR
const TourDetailsPage = lazy(() => import('src/pages/dashboard/tour/details'));
const TourListPage = lazy(() => import('src/pages/dashboard/tour/list'));
const TourCreatePage = lazy(() => import('src/pages/dashboard/tour/new'));
const TourEditPage = lazy(() => import('src/pages/dashboard/tour/edit'));
// FILE MANAGER
const FileManagerPage = lazy(() => import('src/pages/dashboard/file-manager'));
// APP
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));
const MailPage = lazy(() => import('src/pages/dashboard/mail'));
const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));
const KanbanPage = lazy(() => import('src/pages/dashboard/kanban'));
// TEST RENDER PAGE BY ROLE
const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'profile', element: <UserAccountPage /> },
      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
          { path: ':id/events', element: <UserEventPage /> }

        ],
      },
      { path: 'currency-exchange', element: <CurrencyExchangeRateFormPage /> },
      {
        path: 'product',
        children: [
          { element: <ProductListPage />, index: true },
          { path: 'list', element: <ProductListPage /> },
          { path: ':id', element: <ProductDetailsPage /> },
          { path: 'new', element: <ProductCreatePage /> },
          { path: ':id/edit', element: <ProductEditPage /> },
        ],
      },
      {
        path: 'batches',
        children: [
          { element: <BatchesListPage />, index: true },
          { path: 'list', element: <BatchesListPage /> },
          // { path: ':id', element: <CategoryViewPage /> },
          { path: 'new', element: <BatchesNewPage /> },
          { path: ':id/edit', element: <BatchesEditPage /> },
        ],
      },
         {
        path: 'profile-analytics',
        children: [
          { element: <ProfileAnalyticsListPage />, index: true },
          { path: 'list', element: <ProfileAnalyticsListPage /> },
          // { path: ':id', element: <CategoryViewPage /> },
          { path: 'new', element: <BatchesNewPage /> },
          { path: ':id/edit', element: <BatchesEditPage /> },
        ],
      },
      {
        path: 'order',
        children: [
          { element: <OrderListPage />, index: true },
          { path: 'list', element: <OrderListPage /> },
          { path: ':id', element: <OrderDetailsPage /> },
        ],
      },
      {
        path: 'invoice',
        children: [
          { element: <InvoiceListPage />, index: true },
          { path: 'list', element: <InvoiceListPage /> },
          { path: ':id', element: <InvoiceDetailsPage /> },
          { path: ':id/edit', element: <InvoiceEditPage /> },
          { path: 'new', element: <InvoiceCreatePage /> },
        ],
      },
      {
        path: 'post',
        children: [
          { element: <BlogPostsPage />, index: true },
          { path: 'list', element: <BlogPostsPage /> },
          { path: ':title', element: <BlogPostPage /> },
          { path: ':title/edit', element: <BlogEditPostPage /> },
          { path: 'new', element: <BlogNewPostPage /> },
        ],
      },
      {
        path: 'blog-author',
        children: [
          { element: <BlogAuthorListPage />, index: true },
          { path: 'list', element: <BlogAuthorListPage /> },
          { path: 'new', element: <BlogAuthorCreatePage /> },
          { path: ':id/edit', element: <BlogAuthorEditPage /> },
        ],
      },
      {
        path: 'job',
        children: [
          { element: <JobListPage />, index: true },
          { path: 'list', element: <JobListPage /> },
          { path: ':id', element: <JobDetailsPage /> },
          { path: 'new', element: <JobCreatePage /> },
          { path: ':id/edit', element: <JobEditPage /> },
        ],
      },
      {
        path: 'category',
        children: [
          { element: <CategoryListPage />, index: true },
          { path: 'list', element: <CategoryListPage /> },
          { path: ':id', element: <CategoryViewPage /> },
          { path: 'new', element: <CategoryCreatePage /> },
          { path: ':id/edit', element: <CategoryEditPage /> },
        ],
      },
      {
        path: 'faqCategory',
        children: [
          { element: <FaqCategoryListPage />, index: true },
          { path: 'list', element: <FaqCategoryListPage /> },
          { path: ':id', element: <FaqCategoryViewPage /> },
          { path: 'new', element: <FaqCategoryNewPage /> },
          { path: ':id/edit', element: <FaqCategoryEditPage /> },
        ],
      },
      {
        path: 'faq',
        children: [
          { element: <FaqListPage />, index: true },
          { path: 'list', element: <FaqListPage /> },
          { path: ':id', element: <FaqViewPage /> },
          { path: 'new', element: <FaqNewPage /> },
          { path: ':id/edit', element: <FaqEditPage /> },
        ],
      },
      {
        path: 'plan',
        children: [
          { element: <PlanListPage />, index: true },
          { path: 'list', element: <PlanListPage /> },
          { path: 'courseList', element: <CourseListPage /> },
          { path: 'serviceList', element: <ServiceListPage /> },
          { path: 'new', element: <PlanCreatePage /> },
          { path: ':id/edit', element: <PlanEditPage /> },
        ],
      },

      {
        path: 'subscription',
        children: [
          { element: <SubscriptionListPage />, index: true },
          { path: 'list', element: <SubscriptionListPage /> },
          { path: ':id', element: <SubscriptionDetailsPage /> },
        ],
      },

      {
        path: 'email',
        children: [
          { element: <EmailListPage />, index: true },
          { path: 'list', element: <EmailListPage /> },
        ],
      },

      {
        path: 'contact',
        children: [
          { element: <ContactListPage />, index: true },
          { path: 'list', element: <ContactListPage /> },
        ],
      },

      
      {
        path: 'cms-plays',
        children: [
          { path: 'new', element: <CmsPlayNewPage /> },
          { path: ':documentId/edit', element: <CmsPlayEditPage /> },
          { element: <CmsPlaysListPage />, index: true },
          { path: 'list', element: <CmsPlaysListPage /> },
        ],
      },

      {
        path: 'learner-progress',
        children: [
          { element: <LearnerProgressListPage />, index: true },
          { path: 'list', element: <LearnerProgressListPage /> },
          { path: 'user/:userId', element: <LearnerProgressUserPage /> },
          { path: ':id', element: <LearnerProgressDetailsPage /> },
        ],
      },

      {
        path: 'pricing',
        children: [
          {
            path: 'tiers',
            children: [
              { element: <PricingTiersListPage />, index: true },
              { path: 'new', element: <PricingTierNewPage /> },
              { path: 'grant', element: <PricingTiersGrantPage /> },
              { path: ':documentId/edit', element: <PricingTierEditPage /> },
            ],
          },
          {
            path: 'plans',
            children: [
              { element: <PricingPlansListPage />, index: true },
              { path: 'new', element: <PricingPlanNewPage /> },
              { path: ':documentId/edit', element: <PricingPlanEditPage /> },
            ],
          },
        ],
      },

      {
        path: 'domains',
        children: [
          { element: <DomainsListPage />, index: true },
          { path: 'new', element: <DomainNewPage /> },
          { path: ':documentId/edit', element: <DomainEditPage /> },
        ],
      },
      {
        path: 'sub-domains',
        children: [
          { element: <SubDomainsListPage />, index: true },
          { path: 'new', element: <SubDomainNewPage /> },
          { path: ':documentId/edit', element: <SubDomainEditPage /> },
        ],
      },

      {
        path: 'marketing',
        children: [
          { path: 'home', element: <MarketingHomePage /> },
          { path: 'banner', element: <MarketingBannerPage /> },
          {
            path: 'faqs',
            children: [
              { element: <MarketingFaqsListPage />, index: true },
              { path: 'new', element: <MarketingFaqNewPage /> },
              { path: ':documentId/edit', element: <MarketingFaqEditPage /> },
            ],
          },
          {
            path: 'testimonials',
            children: [
              { element: <TestimonialsListPage />, index: true },
              { path: 'new', element: <TestimonialNewPage /> },
              { path: ':documentId/edit', element: <TestimonialEditPage /> },
            ],
          },
          {
            path: 'nativity-templates',
            children: [
              { element: <NativityTemplatesListPage />, index: true },
              { path: 'new', element: <NativityTemplateNewPage /> },
              { path: ':documentId/edit', element: <NativityTemplateEditPage /> },
            ],
          },
        ],
      },

      {
        path: 'tour',
        children: [
          { element: <TourListPage />, index: true },
          { path: 'list', element: <TourListPage /> },
          { path: ':id', element: <TourDetailsPage /> },
          { path: 'new', element: <TourCreatePage /> },
          { path: ':id/edit', element: <TourEditPage /> },
        ],
      },
      { path: 'play-platform-settings', element: <PlayPlatformSettingsPage /> },
      {
        path: 'memory',
        children: [
          { path: 'settings', element: <MemorySettingsPage /> },
          { path: 'insights', element: <MemoryInsightsHomePage /> },
          { path: 'insights/users', element: <MemoryInsightsUsersPage /> },
          { path: 'insights/users/:id', element: <MemoryInsightsUserPage /> },
        ],
      },
      { path: 'file-manager', element: <FileManagerPage /> },
      { path: 'mail', element: <MailPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'kanban', element: <KanbanPage /> },
      { path: 'permission', element: <PermissionDeniedPage /> },
      { path: 'blank', element: <BlankPage /> },
    ],
  },
];
